import Picture from "../assets/pic-1-4.png";

const About = () => {
  return (
    <div
      name="about"
      className="w-full min-h-screen bg-[#0a192f] text-gray-300 py-20"
    >
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="pb-12">
          <h2 className="text-4xl sm:text-5xl font-bold inline-block border-b-4 border-cyan-600">
            About Me
          </h2>
          <p className="text-[#8892b0] text-lg mt-4">
            Discipline, precision, and delivery under pressure!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-stretch">
          <div className="flex flex-col space-y-6">
            <div className="text-[#8892b0] text-lg leading-relaxed space-y-4 flex-grow">
              <p>
                Senior{" "}
                <span className="text-cyan-500 font-semibold">
                  Full-Stack Developer
                </span>{" "}
                and multi award-winning Computer Engineer. I approach software
                engineering as a discipline, not a vibe. Clean code, clear
                structure, and predictable outcomes.
              </p>
              <p>
                I specialize in React and Node.js ecosystems with production
                experience across{" "}
                <span className="text-cyan-500 font-semibold">
                  GraphQL (Hasura)
                </span>
                , <span className="text-cyan-500 font-semibold">NestJS</span>,
                REST APIs, and scalable full-stack architectures.
              </p>
              <p>
                I do not miss deadlines. Not in school. Not in college. Not in
                production. If I commit to a delivery date, it ships on time.
                Currently leading development for{" "}
                <span className="text-cyan-500 font-semibold">E-LMIS</span>, the
                Ethiopian Labour Market Information System. The work demands
                precision, reliability, and long-term thinking ... and that is
                exactly how I operate.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <div className="group relative max-w-[28rem] mx-auto lg:mx-0">
              <img
                className="rounded-lg transition duration-500 filter brightness-90 group-hover:brightness-110 shadow-xl"
                src={Picture}
                alt="Beki's award ceremony"
              />
              <div className="absolute top-4 right-4 bg-cyan-600 text-white px-4 py-2 rounded-lg font-semibold shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                CGPA: 3.97/4.00
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
